import $ from 'jquery';

export default class DeferredImage {
    init() {
        $(document).ready(this.ready());
    }

    ready() {
        let $srcs = $('img[data-deferred-src]');
        let $srcsets = $('source[data-deferred-srcset]');
        this.loadPriority('high', $srcs);
        this.loadPriority('high', $srcsets, true);
        this.loadPriority('med', $srcs);
        this.loadPriority('med', $srcsets, true);
        this.loadPriority('low', $srcs);
        this.loadPriority('low', $srcsets, true);
        $srcs = null;
        $srcsets = null;
    }

    loadPriority(priority, $collection, srcset = false) {
        $collection.each(function (index, element) {
            let $element = $(element);
            if (priority === DeferredImage.getPriority($element)) {
                if (srcset === true) {
                    $element.attr('srcset', $element.data('deferred-srcset'));
                } else {
                    $element.attr('src', $element.data('deferred-src'));
                }
            }
        });
    }

    static getPriority($element) {
        let priority = $element.data('deferred-priority');

        if (priority !== 'high' && priority !== 'med') {
            priority = 'low';
        }

        return priority;
    }
}